<template>
  <div
    :class="['sj-tag', `tag-${type}`, `tag-theme-${theme}`, `tag-size-${size}`]"
    v-on="$listeners"
  >
    <slot></slot>
    <SjIcon
      v-if="closable"
      theme="2"
      class="sj-tag-icon"
      iconClass="commulti_close"
      v-bind="iconStyle"
      @click.native.stop="handleClose"
    >
    </SjIcon>
  </div>
</template>

<script>
/**
 * tag组件，可复用的带颜色简单标签
 * 可配置是否有删除(关闭)按钮
 */
import sizeMixin from "../../../utils/sizeMixin";
export default {
  name: "SjTag",
  mixins: [sizeMixin],
  props: {
    type: {
      type: String,
      default: "display" //display/closeonly
    },
    theme: {
      type: String,
      default: "1"
    }
  },
  computed: {
    closable() {
      return this.type === "closeonly";
    },
    iconStyle() {
      if (this.size === "middle" || this.size === "large") {
        return {
          iconSize: 12,
          size: 20
        };
      } else {
        return {
          iconSize: 8,
          size: 16
        };
      }
    }
  },
  methods: {
    handleClose(event) {
      this.$emit("close", event);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @display-theme: 1, 2, 3, 4, 5;
  @close-theme: 1, 2;
.sj-tag {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: @base-border-radius;
  padding: 0 5px;
  &.tag-display {
    each(@display-theme, {
      &.tag-theme-@{value} {
        @theme-color-name: "color-tag-display-@{value}";
        @theme-color: @@theme-color-name;
        background-color: fade(@theme-color,20%);
        color: @theme-color
      }
    })
  }

  &.tag-closeonly{
    &.tag-theme-1{
      background-color: @color-gray-2;
      color: @color-dark;
    }
    &.tag-theme-2{
      background-color: @color-productlight;
      color: @color-dark;
    }
  }



  each(@sizes, {
    &.tag-size-@{value} {
      .size(@value)
    }
  });

  .sj-tag-icon {
    margin-left: 5px;
  }
}
</style>
